// extracted by mini-css-extract-plugin
module.exports = {"introWrapper":"intro_introWrapper__kZX8S","introCardWrapper":"intro_introCardWrapper__18Q2Z"};